import type { ReactNode } from "react";

/**
 * Editorial settings primitives: a ruled section with a small-caps label in
 * the margin, a definition row, and a text-only action. Mirrors the Clipboard
 * details panel and the docs pages — no cards, no icons, no filled buttons.
 */
export const SettingsSection = ({
  id,
  label,
  children,
}: {
  id: string;
  label: string;
  children: ReactNode;
}) => (
  <section
    aria-labelledby={id}
    className="grid gap-x-10 gap-y-3 border-t border-zinc-200/80 py-7 md:grid-cols-[8.5rem_minmax(0,1fr)]"
  >
    <h2
      id={id}
      className="font-ui pt-1 text-zinc-400"
    >
      {label}
    </h2>
    <div className="min-w-0">{children}</div>
  </section>
);

/** One label / value line. Values that are numbers should be passed in mono. */
export const SettingsRow = ({
  label,
  children,
  className = "",
}: {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}) => (
  <div
    className={`font-ui flex items-baseline justify-between gap-6 border-b border-zinc-200/60 py-2 text-sm leading-6 last:border-b-0 ${className}`}
  >
    <dt className="shrink-0 text-zinc-500">{label}</dt>
    <dd className="min-w-0 text-right text-zinc-900">{children}</dd>
  </div>
);

export const SETTINGS_ACTION =
  "font-ui text-sm leading-6 text-zinc-500 transition-colors hover:text-zinc-900 disabled:opacity-50";

export const SETTINGS_MONO = "hero-mono text-sm tabular-nums";
